import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SendDeviceCommandMutationVariables = Types.Exact<{
  input: Types.SendDeviceCommandInput;
}>;


export type SendDeviceCommandMutation = { __typename?: 'Mutation', sendDeviceCommand: { __typename?: 'SendDeviceCommandPayload', changeId?: string | null, device?: { __typename?: 'DeviceStateData', deviceId: string, status: Types.DeviceStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClaimDeviceMutationVariables = Types.Exact<{
  input: Types.ClaimDeviceInput;
}>;


export type ClaimDeviceMutation = { __typename?: 'Mutation', claimDevice: { __typename?: 'DevicePayload', device?: { __typename?: 'DeviceStateData', deviceId: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, locationId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RenameDeviceMutationVariables = Types.Exact<{
  input: Types.RenameDeviceInput;
}>;


export type RenameDeviceMutation = { __typename?: 'Mutation', renameDevice: { __typename?: 'DevicePayload', device?: { __typename?: 'DeviceStateData', deviceId: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, locationId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AssignDeviceLocationMutationVariables = Types.Exact<{
  input: Types.AssignDeviceLocationInput;
}>;


export type AssignDeviceLocationMutation = { __typename?: 'Mutation', assignDeviceLocation: { __typename?: 'DevicePayload', device?: { __typename?: 'DeviceStateData', deviceId: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, locationId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetDeviceDesiredConfigMutationVariables = Types.Exact<{
  input: Types.SetDeviceDesiredConfigInput;
}>;


export type SetDeviceDesiredConfigMutation = { __typename?: 'Mutation', setDeviceDesiredConfig: { __typename?: 'DevicePayload', device?: { __typename?: 'DeviceStateData', deviceId: string, serial: string, name: string, profile: Types.DeviceProfile, status: Types.DeviceStatus, locationId?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevokeDeviceCredentialMutationVariables = Types.Exact<{
  input: Types.RevokeDeviceCredentialInput;
}>;


export type RevokeDeviceCredentialMutation = { __typename?: 'Mutation', revokeDeviceCredential: { __typename?: 'DevicePayload', device?: { __typename?: 'DeviceStateData', deviceId: string, status: Types.DeviceStatus, credentialStatus: Types.DeviceCredentialStatus, credentialRevokedAt?: Types.TDateISO | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SendDeviceCommandDocument = new TypedDocumentString(`
    mutation SendDeviceCommand($input: SendDeviceCommandInput!) {
  sendDeviceCommand(input: $input) {
    device {
      deviceId
      status
    }
    changeId
    errors {
      code
      message
    }
  }
}
    `);
export const ClaimDeviceDocument = new TypedDocumentString(`
    mutation ClaimDevice($input: ClaimDeviceInput!) {
  claimDevice(input: $input) {
    device {
      ...DeviceState
    }
    errors {
      code
      message
    }
  }
}
    fragment DeviceState on DeviceStateData {
  deviceId
  serial
  name
  profile
  status
  locationId
}`);
export const RenameDeviceDocument = new TypedDocumentString(`
    mutation RenameDevice($input: RenameDeviceInput!) {
  renameDevice(input: $input) {
    device {
      ...DeviceState
    }
    errors {
      code
      message
    }
  }
}
    fragment DeviceState on DeviceStateData {
  deviceId
  serial
  name
  profile
  status
  locationId
}`);
export const AssignDeviceLocationDocument = new TypedDocumentString(`
    mutation AssignDeviceLocation($input: AssignDeviceLocationInput!) {
  assignDeviceLocation(input: $input) {
    device {
      ...DeviceState
    }
    errors {
      code
      message
    }
  }
}
    fragment DeviceState on DeviceStateData {
  deviceId
  serial
  name
  profile
  status
  locationId
}`);
export const SetDeviceDesiredConfigDocument = new TypedDocumentString(`
    mutation SetDeviceDesiredConfig($input: SetDeviceDesiredConfigInput!) {
  setDeviceDesiredConfig(input: $input) {
    device {
      ...DeviceState
    }
    errors {
      code
      message
    }
  }
}
    fragment DeviceState on DeviceStateData {
  deviceId
  serial
  name
  profile
  status
  locationId
}`);
export const RevokeDeviceCredentialDocument = new TypedDocumentString(`
    mutation RevokeDeviceCredential($input: RevokeDeviceCredentialInput!) {
  revokeDeviceCredential(input: $input) {
    device {
      deviceId
      status
      credentialStatus
      credentialRevokedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SendDeviceCommand: build.mutation<SendDeviceCommandMutation, SendDeviceCommandMutationVariables>({
      query: (variables) => ({ document: SendDeviceCommandDocument, variables })
    }),
    ClaimDevice: build.mutation<ClaimDeviceMutation, ClaimDeviceMutationVariables>({
      query: (variables) => ({ document: ClaimDeviceDocument, variables })
    }),
    RenameDevice: build.mutation<RenameDeviceMutation, RenameDeviceMutationVariables>({
      query: (variables) => ({ document: RenameDeviceDocument, variables })
    }),
    AssignDeviceLocation: build.mutation<AssignDeviceLocationMutation, AssignDeviceLocationMutationVariables>({
      query: (variables) => ({ document: AssignDeviceLocationDocument, variables })
    }),
    SetDeviceDesiredConfig: build.mutation<SetDeviceDesiredConfigMutation, SetDeviceDesiredConfigMutationVariables>({
      query: (variables) => ({ document: SetDeviceDesiredConfigDocument, variables })
    }),
    RevokeDeviceCredential: build.mutation<RevokeDeviceCredentialMutation, RevokeDeviceCredentialMutationVariables>({
      query: (variables) => ({ document: RevokeDeviceCredentialDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSendDeviceCommandMutation, useClaimDeviceMutation, useRenameDeviceMutation, useAssignDeviceLocationMutation, useSetDeviceDesiredConfigMutation, useRevokeDeviceCredentialMutation } = injectedRtkApi;
